import { render, staticRenderFns } from "./ClientesForm.vue?vue&type=template&id=224772f8&scoped=true&lang=pug&"
import script from "./ClientesForm.vue?vue&type=script&lang=js&"
export * from "./ClientesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224772f8",
  null
  
)

export default component.exports